module.exports = __webpack_public_path__ + "img/christmas-gallery-2.c4df51a6.jpg";